export const  UserRoutes = {
    createUser: "/auth/create",
    getUser: "/auth/getAllUsers",
    updateUser: "/auth/updateUser",
    updateProfile: "/auth/updateProfile",
    getProfile: "/auth/getmyProfile",
    deleteUser:'/auth/deleteUser'
  };
    